import moment, { Moment } from 'moment';
import { csrfToken } from './csrf.js';

export default abstract class network {
	public static authToken: string = '';
	public static lastError: INetworkError | null = null;
	
	public static async ag(url: string, dataObject?: any) {
		return network.ajaxPromise('GET', url, dataObject ?? {});
	}
	
	// Helper function to stop having to specify POST as the type
	public static async ap(url: string, dataObject?: any) {
		return network.ajaxPromise('POST', url, dataObject ?? {});
	}
	
	public static async ad(url: string, dataObject?: any) {
		return network.ajaxPromise('DELETE', url, dataObject ?? {});
	}
	
	// External Portal POST helper function
	public static async eap(authToken: string, url: string, dataObject?: any) {
		return network.ajaxPromise('POST', url, dataObject ?? {}, authToken);
	}
	
	private static async ajaxPromise(type: string, url: string, dataObject: any, overrideAuthToken?: string) {
		if (dataObject == null) {
			dataObject = {};
		}
		
		return new Promise((resolve: (payload: AJAXPromisePayload) => void) => {
			if (type.toLowerCase() == 'get') {
				fetch(url, {
					method: 'GET',
					// UNIT-77: identity is the session cookie (sent automatically on
					// same-origin requests); the unified host reads the CSRF token from
					// this header on mutating requests. Kept on GET too so the single
					// choke point is uniform.
					headers: new Headers({
						'Authorization': `Bearer ${overrideAuthToken ?? network.authToken}`,
						'X-CSRF-Token': csrfToken()
					})
				}).then((value: Response) => {
					if (value.status == 200) {
						return value.json();
					} else {
						network.lastError = {
							type,
							url,
							dataObject,
							when: moment()
						};
						
						resolve({
							ok: false,
							payload: {
								reason: `HTTP Error: ${value.status}`
							}
						});
					}
				}).then((data: any) => {
					resolve({
						ok: true,
						payload: data
					});
				}).catch((reason: any) => {
					network.lastError = {
						type,
						url,
						dataObject,
						when: moment()
					};
					
					resolve({
						ok: false,
						payload: {
							reason
						}
					});
				});
			} else {
				fetch(url, {
					method: type,
					headers: new Headers({
						'Authorization': `Bearer ${overrideAuthToken ?? network.authToken}`,
						'Content-Type': 'application/json',
						'X-CSRF-Token': csrfToken()
					}),
					body: dataObject ? JSON.stringify(dataObject) : null
				}).then((value: Response) => {
					if (value.status == 200) {
						return value.json();
					} else {
						network.lastError = {
							type,
							url,
							dataObject,
							when: moment()
						};
						
						resolve({
							ok: false,
							payload: {
								reason: `HTTP Error: ${value.status}`
							}
						});
					}
				}).then((data: any) => {
					resolve({
						ok: true,
						payload: data
					});
				}).catch((reason: any) => {
					network.lastError = {
						type,
						url,
						dataObject,
						when: moment()
					};
					
					resolve({
						ok: false,
						payload: {
							reason
						}
					});
				});
			}
		});
	}
}

type AJAXPromisePayload<T = any> = AJAXPromisePayloadSuccess<T> | AJAXPromisePayloadFailure;

interface AJAXPromisePayloadSuccess<T = any> {
	ok: true;
	payload: T;
}

interface AJAXPromisePayloadFailure {
	ok: false;
	payload: {
		reason: string
	};
}

export interface INetworkError {
	type: string;
	url: string;
	dataObject: any;
	when: Moment;
	status?: number;
	message?: string;
}
